export default function * failure ({ error }) {
  // console.log(error)
  // console.log('=== GET UPCOMING APPOINTMENTS [FAILURE] ===')
}
